document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('.header__inline-menu header-menu details').forEach((menu) => {

    let timer;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(timer);

      timer = setTimeout(() => {
        menu.setAttribute('open', '');
      }, 120);
    });

    menu.addEventListener('mouseleave', function () {
      clearTimeout(timer);

      timer = setTimeout(() => {
        menu.removeAttribute('open');
      }, 180);
    });

  });
});